import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { TextField, IconButton, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";

function ResultTableContainer() {
  const [rowData, setRowData] = useState([]);
  const [formDataLength, setFormDataLength] = useState(0);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    axios
      .get("https://backend.form-seef.com/api/results")
      .then((res) => {
        if (res && res.data && res.data.results) {
          const modifiedData = res.data.results.map(item => ({
            ...item,
            studentName: `${item.first_name} ${item.last_name}`
          }));
          setRowData(modifiedData);
          setFormDataLength(res.data.count);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const filteredRowData = useMemo(() => {
    if (!searchText) {
      return rowData;
    }
    const lowerCaseSearchText = searchText.toLowerCase();
    return rowData.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(lowerCaseSearchText)
      )
    );
  }, [rowData, searchText]);

  const handleFilePreview = (file_path, file_name) => {
    console.log("File Path:", file_path);
    console.log("File Name:", file_name);

    if (file_name) {
      const fileExtension = file_name.split(".").pop().toLowerCase();

      if (["pdf", "jpg", "jpeg", "png"].includes(fileExtension)) {
        window.open(
          `https://backend.form-seef.com/storage/app/${file_path}`,
          "_blank"
        );
      } else {
        Swal.fire(
          "Unsupported File",
          "Preview is available only for PDF, JPG, JPEG, and PNG files",
          "warning"
        );
      }
    } else {
      Swal.fire(
        "File Name Missing",
        "File name is missing for this row",
        "error"
      );
    }
  };

  const columns = [
    { field: "id", headerName: "SR. NO.", width: 70 },
    { 
      field: "studentName", 
      headerName: "STUDENT NAME", 
      width: 200 
    },
    { field: "cnic", headerName: "STUDENT CNIC", width: 150 },
    {
      field: "father_name",
      headerName: "FATHER / GUARDIAN NAME",
      width: 200,
    },
    { field: "mobile", headerName: "CELL PHONE NO", width: 200 },
    { field: "university_id", headerName: "UNIVERSITY", width: 150 },
    { field: "discipline_id", headerName: "DISCIPLINE", width: 150 },
    { field: "roll_number", headerName: "UNIV. REG. NO.", width: 200 },
    { field: "domicile_id", headerName: "DOMICILE", width: 150 },
    { 
      field: "file_name",
      headerName: "RESULT",
      width: 200,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleFilePreview(params.row.file_path, params.row.file_name)}
        >
          Preview File
        </Button>
      )
    }
  ];

  return (
    <div className="flex flex-col items-center justify-center mt-2">
      <div className="bg-white rounded-lg shadow-md p-4 hover:transform hover:-translate-y-2 hover:bg-slate-300 hover:transition hover:duration-300 hover:ease-in-out flex flex-col items-center cursor-pointer">
        {formDataLength ? (
          <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
            {formDataLength}
          </div>
        ) : (
          <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
            Loading...
          </div>
        )}

        <div className="p-2 text-center">
          <h2 className="font-bold mb-2">Candidates Result</h2>
          <p className="text-gray-700 text-base">Total Results uploaded</p>
        </div>
      </div>

      <div className="" style={{ width: "100%" }}>
        <div className="p-3">
          <TextField
            type="text"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            variant="outlined"
            className="bg-white"
          />
        </div>
        <div className="bg-white h-96 p-3">
          <DataGrid
            rows={filteredRowData}
            columns={columns}
            components={{
              Toolbar: GridToolbar,
            }}
            pagination
            pageSize={10}
            rowsPerPageOptions={[10, 20, 50]}
            disableSelectionOnClick
          />
        </div>
      </div>
    </div>
  );
}

export default ResultTableContainer;

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { TextField, IconButton, Button } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Swal from "sweetalert2";

// function ResultTableContainer() {
//   const [rowData, setRowData] = useState([]);
//   const [formDataLength, setFormDataLength] = useState(0);
//   const [searchText, setSearchText] = useState("");

//   useEffect(() => {
//     let isMounted = true;
//     const source = axios.CancelToken.source();

//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://backend.form-seef.com/api/results",
//           { cancelToken: source.token }
//         );

//         if (isMounted && response.data && response.data.results) {
//           const tableData = response.data.results.map((item) => ({
//             id: item.id,
//             studentName: `${item.first_name} ${item.last_name}`,
//             cnic: item.cnic,
//             fatherName: item.father_name,
//             mobile: item.mobile,
//             universityId: item.university_id,
//             disciplineId: item.discipline_id,
//             rollNumber: item.roll_number,
//             domicileId: item.domicile_id,
//             fileName: item.file_name,
//           }));
//           setRowData(tableData);
//           setFormDataLength(response.data.count);
//         }
//       } catch (error) {
//         console.log(error);
//         // Handle error here (e.g., show error message to the user)
//       }
//     };

//     fetchData();

//     return () => {
//       isMounted = false;
//       source.cancel("Request canceled");
//     };
//   }, []);

//   const filteredRowData = useMemo(() => {
//     if (!searchText) {
//       return rowData;
//     }
//     const lowerCaseSearchText = searchText.toLowerCase();
//     return rowData.filter((row) =>
//       Object.values(row).some(
//         (value) =>
//           typeof value === "string" &&
//           value.toLowerCase().includes(lowerCaseSearchText)
//       )
//     );
//   }, [rowData, searchText]);

//   const handleEdit = (id) => {
//     const rowToEdit = rowData.find((row) => row.id === id);
//     if (rowToEdit) {
//       Swal.fire({
//         title: "Edit Row",
//         text: "Are you sure you want to edit this row?",
//         icon: "question",
//         showCancelButton: true,
//         confirmButtonText: "Edit",
//         cancelButtonText: "Cancel",
//         reverseButtons: true,
//       }).then((result) => {
//         if (result.isConfirmed) {
//           axios
//             .put(`https://backend.form-seef.com/api/update-form/${id}`, rowToEdit)
//             .then((res) => {
//               console.log("Data updated successfully:", res.data);
//               const updatedRowData = rowData.map((row) =>
//                 row.id === id ? rowToEdit : row
//               );
//               setRowData(updatedRowData);
//               Swal.fire("Success", "Data updated successfully", "success");
//             })
//             .catch((err) => {
//               console.log("Error updating data:", err);
//               Swal.fire("Error", "Failed to update data", "error");
//             });
//         }
//       });
//     }
//   };

//   const handleDelete = (id) => {
//     Swal.fire({
//       title: "Delete Row",
//       text: "Are you sure you want to delete this row?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       cancelButtonText: "Cancel",
//       reverseButtons: true,
//       dangerMode: true,
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios
//           .delete(`https://backend.form-seef.com/api/delete-single-form/${id}`)
//           .then((res) => {
//             console.log("Data deleted successfully:", res.data);
//             const updatedRowData = rowData.filter((row) => row.id !== id);
//             setRowData(updatedRowData);
//             Swal.fire("Success", "Data deleted successfully", "success");
//           })
//           .catch((err) => {
//             console.log("Error deleting data:", err);
//             Swal.fire("Error", "Failed to delete data", "error");
//           });
//       }
//     });
//   };

//   const handleFilePreview = (file_path, file_name) => {
//     console.log("File Path:", file_path);
//     console.log("File Name:", file_name);

//     if (file_name) {
//       const fileExtension = file_name.split(".").pop().toLowerCase();

//       if (["pdf", "jpg", "jpeg", "png"].includes(fileExtension)) {
//         // Remove "public/" from the file path
//         // const cleanFilePath = file_path.replace("public/", "");

//         window.open(
//           `https://backend.form-seef.com/storage/app/${file_path}`,
//           "_blank"
//         );
//       } else {
//         Swal.fire(
//           "Unsupported File",
//           "Preview is available only for PDF, JPG, JPEG, and PNG files",
//           "warning"
//         );
//       }
//     } else {
//       Swal.fire(
//         "File Name Missing",
//         "File name is missing for this row",
//         "error"
//       );
//     }
//   };
//   // const generateSerialNumber = (index) => index + 1;
//   const columns = [
//     { field: "id", headerName: "ID", width: 70 },
//     { field: "studentName", headerName: "Student Name", width: 200 },
//     { field: "cnic", headerName: "CNIC", width: 150 },
//     { field: "fatherName", headerName: "Father Name", width: 200 },
//     { field: "mobile", headerName: "Mobile", width: 150 },
//     { field: "universityId", headerName: "University ID", width: 150 },
//     { field: "disciplineId", headerName: "Discipline ID", width: 150 },
//     { field: "rollNumber", headerName: "Roll Number", width: 150 },
//     { field: "domicileId", headerName: "Domicile ID", width: 150 },
//     // { field: "fileName", headerName: "File Name", width: 200 },
//     { field: "fileName", headerName: "RESULT", width: 200, renderCell: (params) => (
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handleFilePreview(params.row.file_path, params.row.file_name)}
//         >
//           Preview File
//         </Button>
//       )},
//   ];

//   return (
//     <div className="flex flex-col items-center justify-center mt-2">
//       <div className="bg-white rounded-lg shadow-md p-4 hover:transform hover:-translate-y-2 hover:bg-slate-300 hover:transition hover:duration-300 hover:ease-in-out flex flex-col items-center cursor-pointer">
//         {formDataLength ? (
//           <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
//             {formDataLength}
//           </div>
//         ) : (
//           <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
//             Loading...
//           </div>
//         )}

//         <div className="p-2 text-center">
//           <h2 className="font-bold mb-2">Candidates Result</h2>
//           <p className="text-gray-700 text-base">Total Results uploaded</p>
//         </div>
//       </div>

//       <div className="" style={{ width: "100%" }}>
//         <div className="p-3">
//           <TextField
//             type="text"
//             placeholder="Search..."
//             value={searchText}
//             onChange={(e) => setSearchText(e.target.value)}
//             variant="outlined"
//             className="bg-white"
//           />
//         </div>
//         <div className="bg-white h-96 p-3">
//           <DataGrid
//             rows={filteredRowData}
//             columns={columns}
//             components={{
//               Toolbar: GridToolbar,
//             }}
//             pagination
//             pageSize={10}
//             rowsPerPageOptions={[10, 20, 50, rowData.length]}
//             disableSelectionOnClick
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ResultTableContainer;


// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { TextField, Button } from "@mui/material"; // Import Button component
// import Swal from "sweetalert2";
// import { saveAs } from 'file-saver';

// function ResultTableContainer() {
//   const [rowData, setRowData] = useState([]);
//   const [searchText, setSearchText] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   useEffect(() => {
//     let isMounted = true;
//     const source = axios.CancelToken.source();

//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://backend.form-seef.com/api/results",
//           { cancelToken: source.token }
//         );

//         if (isMounted && response.data && response.data.results) {
//           const tableData = response.data.results.map((item) => ({
//             id: item.id,
//             studentName: `${item.first_name} ${item.last_name}`,
//             cnic: item.cnic,
//             fatherName: item.father_name,
//             mobile: item.mobile,
//             universityId: item.university_id,
//             disciplineId: item.discipline_id,
//             rollNumber: item.roll_number,
//             domicileId: item.domicile_id,
//             fileName: item.file_name,
//             filePath: item.file_path,
//           }));
//           setRowData(tableData);
//         }
//       } catch (error) {
//         console.log(error);
//         // Handle error here (e.g., show error message to the user)
//       }
//     };

//     fetchData();

//     return () => {
//       isMounted = false;
//       source.cancel("Request canceled");
//     };
//   }, []);

//   const filteredRowData = useMemo(() => {
//     if (!searchText) {
//       return rowData;
//     }
//     const lowerCaseSearchText = searchText.toLowerCase();
//     return rowData.filter((row) =>
//       Object.values(row).some(
//         (value) =>
//           typeof value === "string" &&
//           value.toLowerCase().includes(lowerCaseSearchText)
//       )
//     );
//   }, [rowData, searchText]);

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleFilePreview = (file_path, file_name) => {
//     console.log("File Path:", file_path);
//     console.log("File Name:", file_name);

//     if (file_name) {
//       const fileExtension = file_name.split(".").pop().toLowerCase();

//       if (["pdf", "jpg", "jpeg", "png"].includes(fileExtension)) {
//         // Remove "public/" from the file path
//         // const cleanFilePath = file_path.replace("public/", "");

//         window.open(
//           `https://backend.form-seef.com/storage/app/${file_path}`,
//           "_blank"
//         );
//       } else {
//         Swal.fire(
//           "Unsupported File",
//           "Preview is available only for PDF, JPG, JPEG, and PNG files",
//           "warning"
//         );
//       }
//     } else {
//       Swal.fire(
//         "File Name Missing",
//         "File name is missing for this row",
//         "error"
//       );
//     }
//   };

//   const handleExportToCSV = () => {
//     const csvContent = "data:text/csv;charset=utf-8," + 
//       rowData.map(row => Object.values(row).join(",")).join("\n");

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "exported_data.csv");
//     document.body.appendChild(link); // Required for FF
//     link.click();
//   };

//   const columns = [
//     { field: "id", headerName: "SR. NO.", width: 70 },
//     { field: "studentName", headerName: "STUDENT NAME", width: 200,},
//     { field: "cnic", headerName: "STUDENT CNIC", width: 150 },
//     { field: "fatherName", headerName: "FATHER / GUARDIAN NAME", width: 200 },
//     { field: "mobile", headerName: "CELL PHONE NO", width: 200 },
//     { field: "universityId", headerName: "UNIVERSITY", width: 150 },
//     { field: "disciplineId", headerName: "DISCIPLINE", width: 150 },
//     { field: "rollNumber", headerName: "UNIV. REG. NO.", width: 200 },
//     { field: "domicileId", headerName: "DOMICILE", width: 150 },
//     { field: "fileName", headerName: "RESULT", width: 200,
//       renderCell: (params) => (
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handleFilePreview(params.row.file_path, params.row.file_name)}
//         >
//           Preview File
//         </Button>
//       )
//     }
//   ];

//   return (
//     <div className="flex flex-col items-center justify-center mt-2">
//       <div className="bg-white rounded-lg shadow-md p-4 hover:transform hover:-translate-y-2 hover:bg-slate-300 hover:transition hover:duration-300 hover:ease-in-out flex flex-col items-center cursor-pointer">
//         {rowData.length ? (
//           <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
//             {rowData.length}
//           </div>
//         ) : (
//           <div className="w-20 h-10 flex justify-center items-center text-3xl font-bold">
//             Loading...
//           </div>
//         )}

//         <div className="p-2 text-center">
//           <h2 className="font-bold mb-2">Candidates Result</h2>
//           <p className="text-gray-700 text-base">Total Results uploaded</p>
//         </div>
//       </div>

//       <div className="" style={{ width: "100%" }}>
//         <div className="p-3">
//           <TextField
//             type="text"
//             placeholder="Search..."
//             value={searchText}
//             onChange={(e) => setSearchText(e.target.value)}
//             variant="outlined"
//             className="bg-white"
//           />
//         </div>
//         <div className="bg-white h-96 p-3">
//           <DataGrid
//             rows={filteredRowData.slice(
//               page * rowsPerPage,
//               page * rowsPerPage + rowsPerPage
//             )}
//             columns={columns}
//             components={{
//               Toolbar: () => (
//                 <GridToolbar>
//                   <Button
//                     color="primary"
//                     onClick={handleExportToCSV}
//                   >
//                     Export to CSV
//                   </Button>
//                 </GridToolbar>
//               ),
//             }}
//             pagination
//             pageSize={rowsPerPage}
//             rowCount={filteredRowData.length}
//             paginationMode="server"
//             onPageChange={handlePageChange}
//             rowsPerPageOptions={[10, 20, 50]}
//             onPageSizeChange={handleChangeRowsPerPage}
//             disableSelectionOnClick
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ResultTableContainer;


